/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Tue Dec 19 2023
 **/
export const ZIndex = {
	TOAST: 12000,

	PAGE_LOADING: 11000,

	POPUP: 10000,

	FILEBOX: 9000,
	MAP_SELECT: 9000,

	GNB: 8000,

	INCOMING_PHONE_CALL: 7000,

	KNOCK: 6000,
	CHAT_ALARM: 6000,
	PHONE_CALL_FLOATING: 6000,
	FILE_UPLOAD: 6000,
	SIDEBAR: 6000,
	PANEL_CONTEXT: 6000,

	// WHITEBOARD 관련하여 패널이 안보이는 이슈가 있어 5500으로 낮춤 ->  WHITEBOARD가 채팅 가리는 이슈로 3500으로 조정
	// ( 임시코드 화이트보드 유니티에서 -> 프론트로 변경 예정)
	UNITY_WHITEBOARD: 3500,

	FULL_SIZE_CHAT: 5000,

	CHAT_POPUP: 4000,

	MINIMIZE_CHAT_LIST: 3000,

	TRANSPARENT_CHAT: 2000,

	UNITY: 1000,

	FE_WHITEBOARD: 8500,
	FE_SPACE_UI: 3500, // floating list, communication bar, more button
	FE_CAMERA_FEED: 8600
} as const;

export type ZIndex = (typeof ZIndex)[keyof typeof ZIndex];
